import { render, staticRenderFns } from "./EditDeptAdminDlg.vue?vue&type=template&id=31b9cb54"
import script from "./EditDeptAdminDlg.vue?vue&type=script&lang=js"
export * from "./EditDeptAdminDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports